function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import moment from 'moment';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useSelector } from 'react-redux';
import { imbPatterns as imbPatternsSelector } from 'modules/PatientResults/selectors';
import messages from '../../../messages';
import styles from './Footer.styles.pcss';
const statusToText = {
    Improved: 'Improved',
    NotImproved: 'Not improved',
    Dismissed: 'Dismissed',
    Timedout: 'Timed out',
    Canceled: 'Canceled',
    Overcorrected: 'Overcorrected'
};
export const Footer = ()=>{
    useStyles(styles);
    const imbPatterns = useSelector(imbPatternsSelector);
    const date = moment.utc().format('L');
    const renderimbPatterns = ({ patternDescription, detectedAt, status, endDate, patternExplanation })=>{
        let improved = null;
        if (status === 'NotSet') {
            improved = '.';
        } else {
            const statusText = get(statusToText, status, status);
            improved = endDate ? `, ${statusText} ${moment.utc(endDate).local().format('MM/DD')}.` : `, ${statusText}.`;
        }
        return /*#__PURE__*/ _jsxs("li", {
            children: [
                patternDescription,
                ": Detected ",
                detectedAt,
                improved,
                " ",
                patternExplanation
            ]
        }, `IMBPattern-${detectedAt}-${status}-${endDate}`);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.footer,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.footer__patterns,
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.imbPatterns))
                    }),
                    !imbPatterns || !imbPatterns.length ? /*#__PURE__*/ _jsx("ul", {
                        children: /*#__PURE__*/ _jsx("li", {
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.noimbPatterns))
                        })
                    }) : /*#__PURE__*/ _jsx("ul", {
                        children: imbPatterns.map(renderimbPatterns)
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.footer__notes,
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.glucoseReport.textField))
                    }),
                    /*#__PURE__*/ _jsx("hr", {}),
                    /*#__PURE__*/ _jsx("hr", {}),
                    /*#__PURE__*/ _jsx("hr", {})
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.footer__timestamp,
                children: /*#__PURE__*/ _jsx("p", {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.glucoseReport.reportGeneratedOn), {
                        values: {
                            date
                        }
                    }))
                })
            })
        ]
    });
};
